export const getSkillKey = (skill: any, index: number) => {
  return skill?.id ?? skill?.name ?? index;
};

export const getExperienceKey = (experience: any, index: number) => {
  return experience?.id ?? `${experience?.company_name ?? 'experience'}_${index}`;
};

export const getCourseKey = (course: any, index: number) => {
  return course?.id ?? course?.legacy_id ?? `${course?.course_name ?? 'course'}_${index}`;
};
